module.exports = __webpack_public_path__ + "img/85.18716962.jpg";